import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {
  DailyPlanningMissionOrderPlanningReport,
  DailyTourPlanning,
  MissionOrderPlanningReport,
  Order
} from "../model/Order";
import {AuthService} from "./AuthService";
import {
  MissionOrderCreateStatus,
  OrderRequest,
  SubmitMissionCustomerCancellation,
  TourPlanningDuplicateResponse
} from "../model/OrderRequest";
import {apiconfig} from "../app/api.config";
import {AdditionalTimes} from "../model/AdditionalTimes";
import {CustomerFeedBackCommentValue, CustomerFeedBackValue} from "../model/CustomerFeedBackValue";
import {FieldTeam, FieldTeamStoreUniverse} from "../model/FieldTeam";
import {MissionPlanningComplianceReport} from "../model/MissionPlanningComplianceReport";
import {ActionDone} from "../model/LogaProxy";
import {Agent, LggContext} from "../pages/order-list/order-list";
import {DateService} from "./DateService";
import {e} from "@angular/core/src/render3";

@Injectable()
export class OrderService {

  apiConfig: any = apiconfig;

  constructor(private http: HttpClient, private dateService: DateService, private authService: AuthService) {
  }


  /**
   *
   */
  loadCurrentFieldTeam(skipStore: boolean, storeId: number): Promise<FieldTeamStoreUniverse> {
    let h = this.authService.getHttpAuth();

    let httpParams = new HttpParams();
    if (skipStore != null)
      httpParams = httpParams.append("skipStore", String(skipStore));
    if (storeId != null)
      httpParams = httpParams.append("storeId", String(storeId));

    return this.http
      .get<FieldTeamStoreUniverse>(this.apiConfig.API_URL + '/field-team/current', {
        headers: h, params: httpParams
      }).map((res: any) => FieldTeamStoreUniverse.fromApi(res)).toPromise();
  }

  loadLggContexts(): Promise<LggContext[]> {
    let h = this.authService.getHttpAuth();
    let httpParams = new HttpParams();

    return this.http
      .get<LggContext[]>(this.apiConfig.API_URL + '/lgg-contexts', {
        headers: h, params: httpParams
      }).toPromise();
  }

  loadAgents(lggContextId: number): Promise<Agent[]> {
    let h = this.authService.getHttpAuth();
    let httpParams = new HttpParams();
    httpParams = httpParams.append('ctxId', String(lggContextId));

    return this.http
      .get<LggContext[]>(this.apiConfig.API_URL + '/sales-rep-planning/sales-reps', {
        headers: h, params: httpParams
      }).toPromise();
  }

  loadOrderFromApi(startDate: Date, endDate: Date, p_opId: number): Promise<Order[]> {
    let from = this.dateService.dateToEpochDay(startDate);
    let to = from + 6;
    if (endDate !== undefined && endDate != null) {
      to = this.dateService.dateToEpochDay(endDate);
    }

    let httpParams = new HttpParams();
    let h = this.authService.getHttpAuth();

    httpParams = httpParams.append("from", String(from));
    httpParams = httpParams.append("to", String(to));
    httpParams = httpParams.append("operation", p_opId !== undefined ? String(p_opId) : "");
    httpParams = httpParams.append("status", "");

    return this.http
      .get<any[]>(this.apiConfig.API_URL + '/order/search', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise().then((orders: Order[]) => {
        let o: Order[] = [];
        orders.forEach(oo => o.push(Order.fromJson(oo)));
        return o;
      });

  }

  /**
   * load DailyTourPlanning overview
   * @param dailyTourPlanningId
   */
  loadDailyTourPlanningReport(dailyTourPlanningId: number): Promise<DailyPlanningMissionOrderPlanningReport> {
    console.log("loadDailyTourPlanningReport :: " + dailyTourPlanningId);
    let httpParams = new HttpParams();
    let h = this.authService.getHttpAuth();
    return this.http
      .get<DailyPlanningMissionOrderPlanningReport>(this.apiConfig.API_URL + '/order/daily-tour-planning/' + dailyTourPlanningId, {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise().then((report: DailyPlanningMissionOrderPlanningReport) => {
        console.log("daily-tour-planning loaded")
        console.log(report);
        return new DailyPlanningMissionOrderPlanningReport().fromJson(report);
      });
  }

  loadOrderReport(startDate: Date, endDate: Date, p_opId: number): Promise<MissionOrderPlanningReport> {
    let from = this.dateService.dateToEpochDay(startDate);
    let to = from + 6;
    if (endDate !== undefined && endDate != null) {
      to = this.dateService.dateToEpochDay(endDate);
    }

    let httpParams = new HttpParams();
    let h = this.authService.getHttpAuth();

    httpParams = httpParams.append("from", String(from));
    httpParams = httpParams.append("to", String(to));
    httpParams = httpParams.append("operation", p_opId !== undefined ? String(p_opId) : "");

    return this.http
      .get<any[]>(this.apiConfig.API_URL + '/order/planning-report', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise().then((report: MissionOrderPlanningReport) => {
        console.log("report loaded", report)
        return new MissionOrderPlanningReport().fromJson(report);
      });

  }


  loadOrderFromApiWithWithEpoch(from: number, to: number, p_opId: number, storeId: number): Promise<Order[]> {

    let httpParams = new HttpParams();
    let h = this.authService.getHttpAuth();

    httpParams = httpParams.append("from", String(from));
    httpParams = httpParams.append("to", String(to));
    if (p_opId != null)
      httpParams = httpParams.append("operation", p_opId !== undefined ? String(p_opId) : "");
    httpParams = httpParams.append("status", "");

    if (storeId != null)
      httpParams = httpParams.append("store", "" + storeId);

    return this.http
      .get<any[]>(this.apiConfig.API_URL + '/order/search', {
        headers: h,
        params: httpParams
      }).map((res: any) => res).toPromise().then((orders: Order[]) => {
        let o: Order[] = [];
        orders.forEach(oo => o.push(Order.fromJson(oo)));
        return o;
      });

  }


  /**
   *
   * @param id
   */
  public loadOrder(id: number): Promise<Order> {
    let h = this.authService.getHttpAuth();
    return this.http.get<Order>(this.apiConfig.API_URL + '/order/' + id, {headers: h}).toPromise().then(a => Order.fromJson(a));
  }


  /**
   *
   */
  public updateOrder(orderId: number, orderRequest: OrderRequest): Promise<MissionOrderCreateStatus> {
    let h = this.authService.getHttpAuth();
    return this.http.put<MissionOrderCreateStatus>(this.apiConfig.API_URL + '/order/' + orderId, orderRequest, {headers: h}).toPromise();
  }

  /**
   * try to delete an order, if not possible false will be returned by the API
   */
  public deleteOrder(orderId: number): Promise<boolean> {
    let h = this.authService.getHttpAuth();
    return this.http.delete<boolean>(this.apiConfig.API_URL + '/order/' + orderId, {headers: h}).toPromise();
  }


  /**
   * post an order create request
   * @param orderRequest
   */
  public createOrder(orderRequest: OrderRequest): Promise<MissionOrderCreateStatus> {
    let h = this.authService.getHttpAuth();
    return this.http.post(this.apiConfig.API_URL + '/order/', orderRequest, {headers: h}).map((res: any) => res).toPromise();
  }

  public duplicateTour(tourPlanningIdentifier: number, desDay: number): Promise<TourPlanningDuplicateResponse> {
    let h = this.authService.getHttpAuth();
    return this.http.post(this.apiConfig.API_URL + '/order/tour-duplicate', {
      srcDailyTourPlanning: tourPlanningIdentifier,
      destLogaDay: desDay
    }, {headers: h}).map((res: any) => res).toPromise();
  }


  /**
   *
   * @param sector
   * @param profil
   */
  public checkPlanningCompliance(orderRequest: OrderRequest): Promise<MissionPlanningComplianceReport> {
    let h = this.authService.getHttpAuth();
    return this.http
      .post<MissionPlanningComplianceReport>(this.apiConfig.API_URL + '/order/operation/' + orderRequest.operation + '/customer-planning-setting-compliance', orderRequest, {headers: h})
      .toPromise();
  }


  ab2str(buf): string {
    return String.fromCharCode.apply(null, new Uint8Array(buf));
  }

  /**
   *
   * @param missionOrderId
   * @param content
   */
  uploadClientBriefMission(missionOrderId: number, content: ArrayBuffer, metadata: {
    type: string,
    name: string
  }): Promise<any> {
    let h = this.authService.getHttpAuthNoJson();

    let formData = new FormData();
    formData.append("filename", metadata.name)
    formData.append("file", new Blob([content]));
    formData.append("id", missionOrderId + '');
    formData.append("mimeType", metadata.type);

    return this.http
      .put(this.apiConfig.API_URL + '/order/' + missionOrderId + '/client-brief-mission', formData, {headers: h}).map(res => res).toPromise();
  }

  /**
   *
   * @param id
   */
  deleteActivity(id: number): Promise<number> {
    let h = this.authService.getHttpAuth();
    return this.http
      .delete<number>(this.apiConfig.API_URL + '/operational/activity/' + id, {headers: h}).toPromise();
  }


  loadCustomerFeedBackValueList(): Promise<CustomerFeedBackValue[]> {
    let h = this.authService.getHttpAuth();
    return this.http
      .get<CustomerFeedBackValue[]>(this.apiConfig.API_URL + '/order/customer-feedback/list', {headers: h})
      .toPromise();
  }

  loadCustomerFeedBackCommentValueList(): Promise<CustomerFeedBackCommentValue[]> {
    let h = this.authService.getHttpAuth();
    return this.http
      .get<CustomerFeedBackCommentValue[]>(this.apiConfig.API_URL + '/order/customer-feedback-comment/list', {headers: h})
      .toPromise();
  }

  /**
   *
   * @param id
   * @param p_customerFeedBack
   */
  updateCustomerFeedBack(id: number, p_customerFeedBack: string) {


    let httpParams = new HttpParams().set("cf", p_customerFeedBack);

    let h = this.authService.getHttpAuth();

    // mettre null dans le body pour que les parametres soient bien pris en compte
    return this.http
      .put(this.apiConfig.API_URL + '/order/' + id + '/customer-feedback', null, {headers: h, params: httpParams})
      .toPromise()
      ;


  }

  /**
   *
   * @param id
   * @param p_customerFeedBack
   */
  updateCustomerFeedBackComment(id: number, p_customerFeedBack: number) {


    let h = this.authService.getHttpAuth();

    // mettre null dans le body pour que les parametres soient bien pris en compte
    return this.http
      .put(this.apiConfig.API_URL + '/order/' + id + '/customer-feedback-comment', p_customerFeedBack, {headers: h})
      .toPromise()
      ;


  }

  loadAdditionalWorkingTime(id: number): Promise<AdditionalTimes[]> {
    let h = this.authService.getHttpAuth();
    return this.http
      .get<AdditionalTimes[]>(this.apiConfig.API_URL + '/order/' + id + '/additional-times', {headers: h}).toPromise();
  }

  saveAdditionalWorkingTime(order: number, additionalTimes: AdditionalTimes[]): Promise<any> {
    let h = this.authService.getHttpAuth();
    return this.http
      .put(this.apiConfig.API_URL + '/order/' + order + '/additional-times', additionalTimes, {headers: h}).toPromise();
  }

  /**
   * request cancellation from a Customer user
   * @param orderId
   * @param submitCancellation
   */
  submitCancel(orderId: number, submitCancellation: SubmitMissionCustomerCancellation): Promise<boolean> {
    let h = this.authService.getHttpAuth();
    return this.http.post<boolean>(this.apiConfig.API_URL + '/order/' + orderId + '/customer-cancel-request', submitCancellation, {headers: h}).toPromise();
  }


  createDayTourPlanning(name: string, referenceDate: number): Promise<DailyTourPlanning> {
    let h = this.authService.getHttpAuth();
    return this.http.post<DailyTourPlanning>(this.apiConfig.API_URL + '/order/daily-tour-planning', {
      name: name,
      referenceDate: referenceDate
    }, {headers: h}).toPromise();
  }

  /**
   * request to delete a full DailyTourPlanning, including the missions
   * @param dtpId
   */
  public deleteDailyTourPlanning(dtpId: number): Promise<ActionDone> {
    let h = this.authService.getHttpAuth();
    return this.http.delete<ActionDone>(this.apiConfig.API_URL + '/order/daily-tour-planning/' + dtpId, {headers: h}).toPromise();
  }

  loadPearlsLogo(contextId: any) {
    let h = this.authService.getHttpAuth();
    let httpParams = new HttpParams();
    httpParams = httpParams.append("ctxId", contextId);
    return this.http.get(this.apiConfig.API_URL + '/pearlsconfig/clientlogo', {
      headers: h,
      params: httpParams
    })
  }

}



// WEBPACK FOOTER //
// ./src/services/OrderService.ts